import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

const UserLogged = ({ children }: { children: React.ReactNode }) => {
  const navigate = useNavigate();
  const [checkLoggedIn, setCheckLoggedIn] = useState(false);

  const checkUserToken = () => {
    const userToken = localStorage.getItem("user_token");
    if (userToken) {
      setCheckLoggedIn(false);
      return navigate("/");
    } else {
      setCheckLoggedIn(true);
    }
  };
  useEffect(() => {
    checkUserToken();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
  return <>{checkLoggedIn ? children : null}</>;
};
export default UserLogged;
